import React, { useEffect, useState } from 'react';

interface RouterSafeWrapperProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Wrapper that ensures children only render when router context is available
 * This prevents useLocation() errors during initial render
 */
export function RouterSafeWrapper({ children, fallback }: RouterSafeWrapperProps): React.ReactElement {
  const [isRouterReady, setIsRouterReady] = useState(false);

  useEffect(() => {
    // Check if we're in a browser environment and router context exists
    if (typeof window !== 'undefined') {
      // Use a small delay to ensure React Admin's router has initialized
      const timer = setTimeout(() => {
        setIsRouterReady(true);
      }, 10); // Very small delay, just enough for router setup

      return () => clearTimeout(timer);
    }
  }, []);

  if (!isRouterReady) {
    return <>{fallback || <div>Loading...</div>}</>;
  }

  return <>{children}</>;
}